import { render, staticRenderFns } from "./ShareIconParts.vue?vue&type=template&id=b7de0104&scoped=true"
import script from "./ShareIconParts.vue?vue&type=script&lang=ts"
export * from "./ShareIconParts.vue?vue&type=script&lang=ts"
import style0 from "./ShareIconParts.vue?vue&type=style&index=0&id=b7de0104&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7de0104",
  null
  
)

export default component.exports